import React from "react";
import CharacterList from './components/CharacterList'


export default function App() {
  return (
    <main>   
      <CharacterList/>
    </main>
  );
}
